// ============================================================
// 设备指纹生成工具
// ============================================================

/**
 * 生成设备指纹
 * 基于浏览器特征生成唯一标识，同一设备无论换网络都相同
 */
export async function generateFingerprint(): Promise<string> {
  const components: string[] = []

  // 1. UserAgent
  components.push(navigator.userAgent)

  // 2. 屏幕分辨率
  components.push(`${screen.width}x${screen.height}`)
  components.push(`${screen.colorDepth}`)

  // 3. 时区
  components.push(Intl.DateTimeFormat().resolvedOptions().timeZone)

  // 4. 语言
  components.push(navigator.language)

  // 5. 硬件并发数
  components.push(`${navigator.hardwareConcurrency || 0}`)

  // 6. 设备内存
  components.push(`${(navigator as any).deviceMemory || 0}`)

  // 7. 触摸点数
  components.push(`${navigator.maxTouchPoints || 0}`)

  // 8. Canvas 指纹
  try {
    const canvas = document.createElement('canvas')
    canvas.width = 200
    canvas.height = 50
    const ctx = canvas.getContext('2d')
    if (ctx) {
      ctx.textBaseline = 'top'
      ctx.font = '14px Arial'
      ctx.fillStyle = '#f60'
      ctx.fillRect(125, 1, 62, 20)
      ctx.fillStyle = '#069'
      ctx.fillText('广发圩', 2, 15)
      components.push(canvas.toDataURL())
    }
  } catch {
    components.push('canvas-error')
  }

  // 9. WebGL 渲染器
  try {
    const canvas = document.createElement('canvas')
    const gl = canvas.getContext('webgl')
    if (gl) {
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
      if (debugInfo) {
        components.push(gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL))
        components.push(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL))
      }
    }
  } catch {
    components.push('webgl-error')
  }

  // 10. 指纹拼接后哈希
  const raw = components.join('|||')
  return await sha256(raw)
}

/**
 * SHA-256 哈希
 */
async function sha256(message: string): Promise<string> {
  const msgBuffer = new TextEncoder().encode(message)
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}
